import React from 'react';
import ButtonWithConfirmation from './ButtonWithConfirmation';
import {injectIntl} from 'react-intl';

function SaveButtonWithConfirmation({ onConfirm, toggleButtonClassName, intl }) {
  return (
    <ButtonWithConfirmation
      dropdownClassname="bmc-card-delete-button"
      confirmationMessage={intl.formatMessage({
        id: 'default_save_confirmation',
      })}
      option1Label={intl.formatMessage({ id: 'default_save_cancel_label' })}
      option2Label={intl.formatMessage({
        id: 'default_save_confirm_label',
      })}
      onOption2Select={onConfirm}
      toggleButtonClassName={toggleButtonClassName}
      dropup
    >
      {intl.formatMessage({ id: 'finish' })}
    </ButtonWithConfirmation>
  );
}

export default injectIntl(SaveButtonWithConfirmation);
